export default __webpack_public_path__ + "static/media/Snd43.5d42929c.mp3";